import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useRef, useContext, useEffect } from 'react';
import { Waypoint } from 'react-waypoint';
import ddt from '@wix/da-ddt';
import { isActiveThread, updateCommentOffset } from '../../helpers';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SimpleThread from '../SimpleThread';
import OffsetTrackingComment from '../../_partials/OffsetTrackingComment';
const logger = ddt.createLogger('comments');
const resetCommentOffset = ()=>updateCommentOffset();
const OffsetTrackingCommentThread = (_param)=>{
    var { className  } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const threadStartRef = useRef(null);
    const isMobile = useContext(MobileContext);
    useEffect(()=>{
        const threadStart = threadStartRef.current;
        if (isActiveThread(props.commentableTypeId, props.commentableItemId) && threadStart) {
            logger.log('Scrolling to active thread');
            scrollIntoViewWithHeader(threadStart, isMobile);
        }
    }, [
        isMobile,
        props.commentableTypeId,
        props.commentableItemId
    ]);
    return /*#__PURE__*/ React.createElement(Waypoint, {
        onLeave: resetCommentOffset
    }, /*#__PURE__*/ React.createElement("div", {
        className: className,
        ref: threadStartRef
    }, /*#__PURE__*/ React.createElement(SimpleThread, _extends({}, props, {
        commentComponent: OffsetTrackingComment
    }))));
};
OffsetTrackingCommentThread.displayName = 'OffsetTrackingCommentThread';
export default OffsetTrackingCommentThread;
